import { LegService } from '@approot/services/leg/leg.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SubscriptionSink } from '@approot/utilities';
import { ProductsConfigService, UserStorageService } from '@approot/services';
import {
  KeyBoolean,
  UserPreferencesState,
  UserPreferencesStateKey
} from '@approot/models';

type Rows =
  | 'marginInAlternativeCurrency'
  | 'optionNotional'
  | 'exerciseProbability'
  | 'interestConvention';

@Component({
  selector: 'app-dcd-results-display',
  templateUrl: './dcd-results-display.component.html',
  styleUrls: ['./dcd-results-display.component.scss']
})
export class DcdResultsDisplayComponent implements OnDestroy, OnInit {
  @Input() public pricedLeg: any;
  @Input() public depositCurrency: any;
  @Input() public alternativeCurrency: string;
  public dcdResultsExpanded: boolean;
  private subsink = new SubscriptionSink();
  private pricingDisplaySettings: KeyBoolean = {};
  private availableResults: KeyBoolean = {};
  constructor(
    private legService: LegService,
    private productsConfigService: ProductsConfigService,
    private userStorageService: UserStorageService
  ) {
    this.dcdResultsExpanded = this.legService.dcdResultsExpanded;
    this.subsink.sink = this.userStorageService
      .storeChangesObservable<UserPreferencesState>(UserPreferencesStateKey)
      .subscribe(prefs => {
        this.pricingDisplaySettings = prefs['PricingDisplayPrefs'];
      });
  }
  public ngOnInit(): void {
    this.productsConfigService.pricingResultsInfo.dcdSpecifications.forEach(
      result => (this.availableResults[result.shortName] = true)
    );
  }

  public ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }

  public isRowEnabled(name: Rows): boolean {
    const ret = this.pricingDisplaySettings[name];
    return (ret ?? true) && this.availableResults[name];
  }
}
